import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-countdown', 'days', 'Päevad');
Labels.set('ui-countdown', 'hours', 'Tunnid');
Labels.set('ui-countdown', 'minutes', 'Minutid');
Labels.set('ui-countdown', 'seconds', 'Sekundid');
